import { resetEntityImpressionId } from '~/app/store/analytics/entityImpressionId'
import { galleryImpressionsTrackingSelectorFactory } from '~/app/store/analytics/reducer'
import { ThunkDispatch } from '~/app/store/interface'
import { AnalyticsNames } from 'shared/constants'
import type { IAnalytics } from 'shared/analytics/interface'
import type { State } from 'shared/types/gallery/state'

export const trackDirectQVDismissImpression = (designId: string, analytics: IAnalytics) => (_dispatch: ThunkDispatch, getState: () => State.GlobalState) => {
  resetEntityImpressionId(designId)
  const selectImpressions = galleryImpressionsTrackingSelectorFactory()
  const impression = selectImpressions(getState(), analytics, AnalyticsNames.DesignTile)
  analytics.trackImpression(impression)
}
